export default __webpack_public_path__ + "static/media/band_of_force.f760e4be.jpg";